import moment from "moment";
import React, { useEffect } from "react";
import ReactTable from "react-table";

const CSAMemberTable = ({ selectedCsa, csaMembers, doListCSAMembers, recentEnrollmentId }) => {
  const [pageSize, setPageSize] = React.useState(5);
  const [page, setPage] = React.useState(0);

  useEffect(() => {
    // We have a new id or enrollment so go back to page 0
    setPage(0);
    doListCSAMembers({ csa_id: selectedCsa?.csa?.id, email: selectedCsa?.csa_user?.email, csa_type: selectedCsa?.csa?.csa_type, page: 0, limit: pageSize });
  }, [selectedCsa?.csa?.id, recentEnrollmentId]);

  return <ReactTable
    data={csaMembers || []}
    loading={!csaMembers}
    sortable={false}
    onPageChange={(page) => {
      setPage(page);
      doListCSAMembers({ csa_id: selectedCsa.csa.id, email: selectedCsa.csa_user.email, csa_type: selectedCsa.csa.csa_type, page, limit: pageSize});
    }}
    onPageSizeChange={(size, page) => {
      setPage(page);
      setPageSize(size);
      doListCSAMembers({ csa_id: selectedCsa.csa.id, email: selectedCsa.csa_user.email, csa_type: selectedCsa.csa.csa_type, page, limit: size});
    }}
    pages={Math.ceil(selectedCsa.csa_members_total / pageSize)}
    page={page}
    manual
    columns={[
      {
        Header: "Member ID",
        accessor: "member_id",
        Cell: (row) => {
          return (row.value) ? <a href={`/members/${row.value}/details`}>{row.value}</a> : "pending";
        },
      },
      {
        Header: "Meter ID",
        accessor: "meter.meter_identifier",
      },
      {
        Header: "Status",
        accessor: "meter.status",
      },
      {
        Header: "Meter Type",
        accessor: "meter_type",
      },
      {
        Header: "On CSA",
        accessor: "meter.on_csa",
        Cell: (row) => {
          return (row.value) ? "Yes" : "No";
        },
      },
      {
        Header: "Created",
        accessor: "created",
        Cell: (row) => {
          return (row.value) ? moment(row.value).local().format("YYYY/MM/DD") : "pending";
        }
      }
    ]}
    defaultPageSize={5}
  />;
}

export default CSAMemberTable;
